import { useAnalytics } from '@/services/analytics';
import CtaBanner from './CtaBanner';
import { useAppBanner } from './hooks';

const AgentsBanner = () => {
    const { close } = useAppBanner();
    const mixpanel = useAnalytics();

    const handleCta = async () => {
        mixpanel?.track('agents-banner', { event: 'click' });
        window.open('https://www.d-id.com/agents', '_blank');
        close();
    };

    return <CtaBanner title="D-ID Agents limited release is now open!" ctaText="Join waitlist" onCta={handleCta} />;
};

export default AgentsBanner;
